<template>

  <div class="wrap">
    <!-- 导航 -->
    <div class="page-header">
        <Nav :activeId="activeId" />
    </div>

    <!-- 轮播图 -->
    <div class="section-one img-bg">
      <!-- <img src="../../img/case/global/bg.jpg"  class="bg"/> -->

      <div class="nav-bar">
        <div class="nav-bar_label">Conex Bänninger Discovery</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>探索班尼戈</span><span>优秀案例</span>全球案例
        </div>
      </div>
      <!-- <div class="nav-bar">
        <img src="../../img/case/global/nav-top.png" class="product global-case" />
      </div> -->

      <div class="sub-title">
        <img src="../../img/case/global/sub-title2.png" />
      </div>

      <div class="index-section-swiper">
        <div class="index-swiper-container" ref="interSwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in swiperIndex" :key="index">
                
                <div class="img">
                  <img :src="item.img" class="" alt="" />
                  <div class="mask">
                    <img src="../../img/case/global/mask-bg.png" />
                    <div class="layer">
                      <div class="layer-title">{{ item.name }}</div>
                      <a :href="`/case-detail/${item.id}`">
                        <img src="../../img/news/btn-read.png" class="layer-btn">
                      </a>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
            <div class="swiper-pagination" slot="pagination"></div>

            <div class="swiper-button-prev">
              <img src="../../img/index/icon-left-big.png" />
            </div>

            <div class="swiper-button-next">
              <img src="../../img/index/icon-right-big.png" />
            </div>
        </div>
      </div>
    </div>

    <div class="section-one self-bg">
      <div class="product-2-list">
        <a class="item" href="/case-detail/2">
          <img src="../../img/case/global/item/1.jpg" class="bg" />
        </a>

        <a class="item" href="/case-detail/3">
          <img src="../../img/case/global/item/2.jpg" class="bg" />
        </a>

        <a class="item" href="/case-detail/4">
          <img src="../../img/case/global/item/3.jpg" class="bg" />
        </a>

        <a class="item" href="/case-detail/5">
          <img src="../../img/case/global/item/4.jpg" class="bg" />
        </a>

        <a class="item" href="/case-detail/6">
          <img src="../../img/case/global/item/5.jpg" class="bg" />
        </a>

        <a class="item" href="/case-detail/7">
          <img src="../../img/case/global/item/6.jpg" class="bg" />
        </a>
      </div>
    </div>

    <!-- 尾部 -->
    <Footer />
  </div>

</template>

<script>
// import $ from 'jquery'
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import Swiper from "swiper"
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
export default {
  data() {
    return {
      swiperIndex: [
        {
          id: 1,
          img: require('@/img/case/detail/banner/1.jpg'),
          name: 'The Turning Torso,Malmo, Sweden｜旋转大楼',
          title: 'Conex Compression Is The Versatile Choice To Connect Services In A Controversial Build'
        },
        {
          id: 2,
          img: require('@/img/case/detail/banner/2.jpg'),
          name: 'The Squaire｜法兰克福机场商务中心',
          title: '>B< Press sed for a quick and safe installation of water services at The Squaire, Frankfurt'
        },
        {
          id: 3,
          img: require('@/img/case/detail/banner/3.jpg'),
          name: 'Cloddaith United Church｜约克大教堂',
          title: '>B< Press plays a key part in church restoration'
        },
        {
          id: 4,
          img: require('@/img/case/detail/banner/4.jpg'),
          name: 'The Elbe Philbarmonic Hall｜德国汉堡交响乐音乐厅',
          title: '>B< Press is a reliable choice for connecting water services in The Elbphilharmonie'
        },
        {
          id: 5,
          img: require('@/img/case/detail/banner/5.jpg'),
          name: 'Hyatt Chain｜凯悦酒店',
          title: '>B< Press frees up space at prestigious Victorian Andaz Hotel, London'
        },
        {
          id: 6,
          img: require('@/img/case/detail/banner/6.jpg'),
          name: 'Adelaide Hospital｜阿德莱德医院',
          title: '>B< Press keeps heating and chilled water services hygienic at Adelaide Hospital'
        },
        {
          id: 7,
          img: require('@/img/case/detail/banner/7.jpg'),
          name: 'Hackesches Quartier｜汉克街区',
          title: '>B< Press gets services going without delay at the new Hackesches Quartier'
        }
      ],
      // activeId: 0,
      // activeIndex: 0,
      // index: 0,

      activeId: 1,
      activeIndex: 0,
      index: 0
    }
  },
  components: {
    Nav,
    Footer
  },
  mounted() {
    new Swiper(".index-swiper-container", {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: false,
      loop: true,
      // slideToClickedSlide: true, // 放开后，可以点击任意swiper，会立马将点击的swiper居中并展示相应内容（有个坑，自己摸索，这也是我不放开的原因）
      // 显示分页
      pagination: {
        el: ".swiper-pagination",
        clickable: true, //允许分页点击跳转
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        hideOnClick: true
      },
      on: {
        slideChange: function() {
          console.log(this.realIndex, 'realIndex', this)
        }
      }
    })
  },
  methods: {
    changeSwipe(type) {
      if(type == 'up') {
        this.index -= 1;
      } else if (type == 'down') {
        this.index += 1;
      }
      // this.$refs.swiper.swipeTo(this.index);
      this.$refs.swiper.swipeTo(this.activeIndex+1);
    },
    onChange (index) {
      console.log(index)
      this.activeIndex = index
    },
    goPrev() {
      this.$refs.swiper.prev();
    },
    goNext() {
      this.$refs.swiper.next();
    }
  }
};
</script>

<style scoped lang="less">
.img-bg {
  width: 100%;
  // min-height: 500px;
  max-height: 1110px;
  // padding: 30px 0;
  // background-color: #000;
  overflow: auto;
  padding: 100px 0 200px;
  background: url('../../img/case//global/bg.jpg') no-repeat;
  background-size: 100% auto;
  background-position: center center;
}
.self-bg {
  min-height: 500px;
  // padding: 30px 0;
  background-color: #EFEFEF;
  overflow: auto;
  padding: 100px 0 200px;
}
.sub-title {
  width: 1100px;
  margin: 100px auto 50px;
  img {
    width: 100%;
    height: auto;
  }
}
.swiper-container {
  --swiper-theme-color: #FFF;/* 设置Swiper风格 */
  --swiper-navigation-color: #FFF;/* 单独设置按钮颜色 */
  --swiper-navigation-size: 64px;/* 设置按钮大小 */
  --swiper-navigation-size: 0 !important;
}
/* 去除默认前进后退按钮 */
.swiper-button-prev, .swiper-button-next {
  background: transparent;
  width: 34px;
  height: 34px;
}
.swiper-button-next:after, .swiper-button-prev:after {
  display: none;
}
// 首页顶部
.index-section-swiper {
  width: 1100px;
  margin: 0 auto;
  overflow: auto;
  overflow-x: hidden;
  // overflow-y: visible;
  // height: 1000px;
  .index-swiper-container {
    position: relative;
  }
  .swiper-wrapper {
    .swiper-slide {
      user-select: none;
      text-align: center;
      transition: 300ms;
      box-sizing: border-box;
      // width: 198px;
      .img {
        width: 100%;
        // width: 198px;
        // height: 525px;
        text-align: center;
        margin: auto;
        .mask {
          width: 100%;
          position: absolute;
          bottom: 0;
          .layer {
            width: 1100px;
            position: absolute;
            margin: 0 auto;
            top: 50%;
            padding: 0 50px;
            left: 0;
            right: 0;
            // bottom: 50px;
            color: #FFF;
            text-align: left;
            .layer-title {
              font-size: 20px;
              // font-weight: bold;
              margin-bottom: 10px;
            }
            .layer-btn {
              width: 139px;
              height: 29px;
            }
          }
        }
        img {
          margin: auto;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .swiper-button-prev {
    left: 4%;
    // img {
    //   width: 48px;
    //   height: 48px;
    // }
  }
  .swiper-button-next {
    right: 5%;
    // img {
    //   width: 48px;
    //   height: 48px;
    // }
  }
}
.product-2-list {
  // width: 1092px;
  width: 1100px;
  margin: 0 auto;
  // position: absolute;
  // top: 150px;
  // left: 0;
  // right: 0;
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  .item {
    width: 350px;
    height: 365px;
    position: relative;
    cursor: pointer;
    margin-bottom: 24px;
    overflow: hidden;
    &:hover {
      .title {
        // display: none;
        top: 20% !important;
        transition: all 0.2s;
        // transform: translate(-50%, -20%) !important;
      }
      .show {
        // display: block;
        bottom: 0;
        transition: all 0.5s;
      }
    }
    .bg {
      width: 100%;
      height: 100%;
      z-index: -99;
    }
    .title {
      transition: all 0.2s;
      margin: 0 auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      right: unset;
      bottom: unset;
      object-fit: contain;
      &.t1 { width: 173px; height: 71px; }
      &.t2 { width: 170px; height: 100px; }
      &.t3 { width: 120px; height: 75px; }
      &.t4 { width: 85px; height: 89px; }
      &.t5 { width: 175px; height: 71px; }
      &.t6 { width: 202px; height: 97px; }
    }
    .show {
      position: absolute;
      left: 0;
      bottom: -348px;
      transition: all 0.2s;
      width: 346px;
      height: 248px;
      &.s1 { width: 429px; height: 205px; }
      &.s2 { width: 352px; height: 204px; }
    }
  }
}
</style>
<style lang="less">
/* 小圆点的样式，需要单独写一个不带scoped属性的style标签 */
.swiper-pagination-fraction, .swiper-pagination-custom, 
.swiper-container-horizontal > .swiper-pagination-bullets {
  // bottom: -50px;
  bottom: 20px;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 10px;
}
.swiper-pagination-bullet {
  // margin-left: 20px;
  width: 12px;
  height: 12px;
  border: 1px solid #FFF;
  background-color: transparent;
  opacity: 1;
  &.swiper-pagination-bullet-active {
      // width: 10px;
      // height: 10px;
      border-radius: 50%;
      background-color: #fff;
  }
}
</style>